module.exports = __webpack_public_path__ + "static/media/covidBannerMobile.a47afc04.png";